import { useQuery } from '@tanstack/react-query';

import { Groups } from '@app/client';

import { useGroupId } from './useGroupId';
import { groupsCacheKeys } from './utils';

/**
 * React Hook using React Query to call `/groups/:groupId/can_edit`
 */
export const useGetEditPermission = () => {
    const groupId = useGroupId();

    return useQuery(groupsCacheKeys.canEdit(groupId), () => Groups.callCanEdit({ groupId }), {
        retry: false,
        enabled: Boolean(groupId),
    });
};
